import {
  Button,
  Checkbox,
  Col,
  Descriptions,
  Modal,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import { HeaderPrintForm, Notification } from "components/common";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import ReactToPrint from "react-to-print";

import {
  convertIosStringToDateDayjs,
  formatDateToString,
  formatToCurrencyType,
} from "helper/common";
import { FORMAT_TIME } from "types/enums";
import { getListDoiTuongAPI } from "redux/reducer/common";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";
import dayjs from "dayjs";
import "./PhieuChiDinh.scss";
import { useAppSelector } from "redux/hooks";

const catalogNDV = {
  xetNghiem: [7, 8, 9, 10],
  CDHA: [4],
  dienTim: [5, 6],
  PTTT: [2, 11],
};
const getTenNhomDichVu = (idNhomDichVu) => {
  switch (idNhomDichVu) {
    case 3:
      return "Khám bệnh";
    case 4:
      return "Chẩn đoán hình ảnh";
    case 5:
      return "Thăm dò chức năng";
    case 6:
      return "Điện tim";
    case 7:
      return "Huyết học";
    case 8:
      return "Sinh hóa";
    case 9:
      return "Vi sinh";
    case 10:
      return "Nước tiểu";
    case 2:
      return "Phẫu thuật";
    case 11:
      return "Thủ thuật";
    default:
      return "";
  }
};

const PhieuChiDinh = React.forwardRef((props, ref) => {
  const printRef = useRef<any>();
  const [thongTinBN, setThongTinBN] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const dataPhieu = useAppSelector((state) => state.examination.dataPhieu);
  const [dsChiDinh, setDsChiDinh] = useState<any>([]);
  const [dsNhomChiDinhXN, setDsNhomChiDinhXN] = useState<any>(null);
  const [dsNhomChiDinhDT, setDsNhomChiDinhDT] = useState<any>([]);
  const [dsNhomChiDinhCDHA, setDsNhomChiDinhCDHA] = useState<any>([]);
  const [dsNhomChiDinhPTTT, setDsNhomChiDinhPTTT] = useState<any>([]);
  useImperativeHandle(ref, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    setThongTinBN: setThongTinBN,
    setDsChiDinh: setDsChiDinh,
    setDsNhomChiDinhXN: setDsNhomChiDinhXN,
    setDsNhomChiDinhCDHA: setDsNhomChiDinhCDHA,
    setDsNhomChiDinhDT: setDsNhomChiDinhDT,
    setDsNhomChiDinhPTTT: setDsNhomChiDinhPTTT,
  }));
  useEffect(() => {
    // console.log(dsNhomChiDinhCDHA);
  }, [dsNhomChiDinhCDHA]);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const getTongTien = (ds) => {
    let res = 0;
    ds.map((it) => {
      res += it.donGia * it.soLuong;
    });
    return formatToCurrencyType(res);
  };
  const getTongTienXN = (ds) => {
    let res = 0;
    ds.huyetHoc.map((it) => {
      res += it.donGia * it.soLuong;
    });
    ds.sinhHoa.map((it) => {
      res += it.donGia * it.soLuong;
    });
    ds.viSinh.map((it) => {
      res += it.donGia * it.soLuong;
    });
    ds.nuocTieu.map((it) => {
      res += it.donGia * it.soLuong;
    });
    return formatToCurrencyType(res);
  };
  const getTongTienDVKT = (ds) => {
    let res = 0;
    ds.thuThuat.map((it) => {
      res += it.donGia * it.soLuong;
    });
    ds.phauThuat.map((it) => {
      res += it.donGia * it.soLuong;
    });
    return formatToCurrencyType(res);
  };
  const fields1 = [
    { label: "Họ và tên", value: thongTinBN?.hoTen },
    {
      label: "Ngày sinh",
      value: formatDateToString(
        convertIosStringToDateDayjs(thongTinBN?.ngaySinh)
      ),
    },
  ];
  const fields2 = [
    { label: "Mã bệnh nhân", value: thongTinBN?.maBenhNhan },
    { label: "Mã phiếu khám", value: thongTinBN?.idPhieuKham },
  ];
  const fields3 = [
    {
      label: "Giới tính",
      value:
        gioiTinhOptions.find((it) => it.value === thongTinBN?.gioiTinh)
          ?.label || "--",
    },
    {
      label: "Địa chỉ",
      value: thongTinBN?.diaChiTongHop,
    },
    { label: "Số thẻ BHYT", value: thongTinBN?.maTheBhyt },
    { label: "Nơi KCB ban đầu", value: thongTinBN?.noiDkkcbd },
    { label: "Chẩn đoán", value: thongTinBN?.chanDoan },
  ];
  useEffect(() => {
    if (dataPhieu) {
      setThongTinBN({
        tenBenhNhan: dataPhieu.hoTen,
        ngaySinh: dataPhieu.ngaySinh,
        gioiTinh: dataPhieu.gioiTinh,
        chanDoan: dataPhieu.chanDoan,
        maBenhNhan: dataPhieu.maBenhNhan,
        maPhieuKham: dataPhieu.idPhieuKham,
        diaChiTongHop: dataPhieu.diaChiTongHop,
      });
    }
  }, [dataPhieu]);
  useEffect(() => {}, [thongTinBN]);
  const onPrint = async () => {
    window.print();
    // printRef.current?.setPrintExam(true);
  };
  const cloneToPrint = () => {
    return printRef.current;
  };
  useEffect(() => {}, [
    dsNhomChiDinhXN,
    dsNhomChiDinhCDHA,
    dsNhomChiDinhDT,
    dsNhomChiDinhPTTT,
  ]);
  return (
    <Row>
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        closable={false}
        footer={null}
        width={960}
        destroyOnClose={true}
      >
        <div className="print-form phieu-chi-dinh">
          <div ref={printRef}>
            {dsNhomChiDinhXN ? (
              <div
                className="print-content"
                style={{ padding: "20px 15px 15px 25px" }}
              >
                <HeaderPrintForm></HeaderPrintForm>
                <div style={{ paddingLeft: 24, paddingRight: 24 }}>
                  <div className="container1" style={{ marginBottom: 8 }}>
                    <Row justify={"center"}>
                      <Typography.Title
                        style={{
                          fontWeight: "700",
                          fontSize: 30,
                        }}
                      >
                        PHIẾU CHỈ ĐỊNH XÉT NGHIỆM
                      </Typography.Title>
                    </Row>
                    <Row>
                      <Col span={20}>
                        <Row>
                          <Col span={12}>
                            <Descriptions
                              size="small"
                              column={{
                                xxl: 1,
                                xl: 1,
                                lg: 1,
                                md: 1,
                                sm: 1,
                                xs: 1,
                              }}
                            >
                              {fields1 &&
                                fields1.map((e) => (
                                  <Descriptions.Item label={e.label}>
                                    {e?.value ?? "--"}
                                  </Descriptions.Item>
                                ))}
                            </Descriptions>
                          </Col>
                          <Col span={12}>
                            <Descriptions
                              size="small"
                              column={{
                                xxl: 1,
                                xl: 1,
                                lg: 1,
                                md: 1,
                                sm: 1,
                                xs: 1,
                              }}
                            >
                              {fields2 &&
                                fields2.map((e) => (
                                  <Descriptions.Item label={e.label}>
                                    {e?.value ?? "--"}
                                  </Descriptions.Item>
                                ))}
                            </Descriptions>
                          </Col>
                        </Row>
                        <Row>
                          <Descriptions
                            size="small"
                            column={{
                              xxl: 1,
                              xl: 1,
                              lg: 1,
                              md: 1,
                              sm: 1,
                              xs: 1,
                            }}
                          >
                            {fields3 &&
                              fields3.map((e) => (
                                <Descriptions.Item label={e.label}>
                                  {e?.value ?? "--"}
                                </Descriptions.Item>
                              ))}
                          </Descriptions>
                        </Row>
                      </Col>
                      <Col span={4}>
                        <Row justify={"end"}>
                          <QRCode value={thongTinBN?.maBenhNhan} size={96} />
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  <div className="my-table-custom">
                    <table>
                      <tr>
                        <th style={{ width: "8%" }}>
                          <Typography.Text strong>STT</Typography.Text>
                        </th>
                        <th style={{ width: "36%" }}>
                          <Typography.Text strong>Tên dịch vụ</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Số lượng</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Đơn vị tính</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Đơn giá</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Thành tiền</Typography.Text>
                        </th>
                      </tr>

                      {dsNhomChiDinhXN?.huyetHoc?.length > 0 ? (
                        <>
                          <tr>
                            <td colSpan={6}>
                              <Typography.Text strong>
                                {"Huyết học"}
                              </Typography.Text>
                            </td>
                          </tr>
                          {dsNhomChiDinhXN?.huyetHoc?.map((it, idx) => {
                            return (
                              <tr>
                                <td className="ta-c">
                                  <Typography.Text>{it.index}</Typography.Text>
                                </td>
                                <td className="">
                                  <Typography.Text>
                                    {it.tenDichVu}{" "}
                                  </Typography.Text>
                                </td>
                                <td
                                  className="ta-c"
                                  style={{ textAlign: "center" }}
                                >
                                  <Typography.Text>
                                    {it.soLuong}
                                  </Typography.Text>
                                </td>
                                <td
                                  className="ta-c"
                                  style={{ textAlign: "center" }}
                                >
                                  <Typography.Text>{it.ghiChu}</Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {formatToCurrencyType(it.donGia)}
                                  </Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {formatToCurrencyType(
                                      it.donGia * it.soLuong
                                    )}
                                  </Typography.Text>
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : null}

                      {dsNhomChiDinhXN?.sinhHoa?.length > 0 ? (
                        <>
                          <tr>
                            <td colSpan={6}>
                              <Typography.Text strong>
                                {"Sinh hóa"}
                              </Typography.Text>
                            </td>
                          </tr>
                          {dsNhomChiDinhXN?.sinhHoa?.map((it, idx) => {
                            return (
                              <tr>
                                <td className="ta-c">
                                  <Typography.Text>{it.index}</Typography.Text>
                                </td>
                                <td className="ta-l">
                                  <Typography.Text>
                                    {it.tenDichVu}{" "}
                                    {it?.ghiChu ? `- ${it?.ghiChu}` : ""}{" "}
                                  </Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {it.soLuong}
                                  </Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>{it.ghiChu}</Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {formatToCurrencyType(it.donGia)}
                                  </Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {formatToCurrencyType(
                                      it.donGia * it.soLuong
                                    )}
                                  </Typography.Text>
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : null}

                      {dsNhomChiDinhXN?.viSinh?.length > 0 ? (
                        <>
                          <tr>
                            <td colSpan={6}>
                              <Typography.Text strong>
                                {"Vi sinh"}
                              </Typography.Text>
                            </td>
                          </tr>
                          {dsNhomChiDinhXN?.viSinh?.map((it, idx) => {
                            return (
                              <tr>
                                <td className="ta-c">
                                  <Typography.Text>{it.index}</Typography.Text>
                                </td>
                                <td className="ta-l">
                                  <Typography.Text>
                                    {it.tenDichVu}{" "}
                                    {it?.ghiChu ? `- ${it?.ghiChu}` : ""}{" "}
                                  </Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {it.soLuong}
                                  </Typography.Text>
                                </td>{" "}
                                <td className="ta-c">
                                  <Typography.Text>{it.ghiChu}</Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {formatToCurrencyType(it.donGia)}
                                  </Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {formatToCurrencyType(
                                      it.donGia * it.soLuong
                                    )}
                                  </Typography.Text>
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : null}

                      {dsNhomChiDinhXN?.nuocTieu?.length > 0 ? (
                        <>
                          <tr>
                            <td colSpan={6}>
                              <Typography.Text strong>
                                {"Nước tiểu"}
                              </Typography.Text>
                            </td>
                          </tr>
                          {dsNhomChiDinhXN?.nuocTieu?.map((it, idx) => {
                            return (
                              <tr>
                                <td className="ta-c">
                                  <Typography.Text>{it.index}</Typography.Text>
                                </td>
                                <td className="ta-l">
                                  <Typography.Text>
                                    {it.tenDichVu}{" "}
                                    {it?.ghiChu ? `- ${it?.ghiChu}` : ""}{" "}
                                  </Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {it.soLuong}
                                  </Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>{it.ghiChu}</Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {formatToCurrencyType(it.donGia)}
                                  </Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {formatToCurrencyType(
                                      it.donGia * it.soLuong
                                    )}
                                  </Typography.Text>
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : null}

                      <tr>
                        <td className="ta-c" colSpan={4}>
                          <Typography.Text strong>Tổng tiền</Typography.Text>
                        </td>
                        <td className="ta-c">
                          <Typography.Text>
                            {getTongTienXN(dsNhomChiDinhXN)}
                          </Typography.Text>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <Row
                    justify={"space-between"}
                    style={{ marginTop: "48px", marginRight: "24px" }}
                  >
                    <Col></Col>
                    <Col>
                      <Row justify={"center"}>
                        <Typography.Text>
                          {dayjs().format(`Ngày DD [tháng] MM [năm] YYYY`)}
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>
                          Bác sĩ điều trị
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text type="secondary">
                          (Ký và ghi rõ họ tên)
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"} style={{ marginTop: "48px" }}>
                        <Typography.Text strong>
                          {thongTinBN?.bacSyKham ?? ""}
                        </Typography.Text>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </div>
            ) : null}
            {dsNhomChiDinhCDHA.length > 0 ? (
              <div style={{ pageBreakBefore: "always" }}></div>
            ) : null}
            {dsNhomChiDinhCDHA.length > 0 ? (
              <div
                className="print-content"
                style={{ padding: "20px 15px 15px 25px" }}
              >
                <HeaderPrintForm></HeaderPrintForm>
                <div style={{ paddingLeft: 24, paddingRight: 24 }}>
                  <div className="container1" style={{ marginBottom: 8 }}>
                    <Row justify={"center"}>
                      <Typography.Title
                        style={{
                          fontWeight: "700",
                          fontSize: 30,
                        }}
                      >
                        PHIẾU CHỈ ĐỊNH CĐHA
                      </Typography.Title>
                    </Row>
                    <Row>
                      <Col span={20}>
                        <Row>
                          <Col span={12}>
                            <Descriptions
                              size="small"
                              column={{
                                xxl: 1,
                                xl: 1,
                                lg: 1,
                                md: 1,
                                sm: 1,
                                xs: 1,
                              }}
                            >
                              {fields1 &&
                                fields1.map((e) => (
                                  <Descriptions.Item label={e.label}>
                                    {e?.value ?? "--"}
                                  </Descriptions.Item>
                                ))}
                            </Descriptions>
                          </Col>
                          <Col span={12}>
                            <Descriptions
                              size="small"
                              column={{
                                xxl: 1,
                                xl: 1,
                                lg: 1,
                                md: 1,
                                sm: 1,
                                xs: 1,
                              }}
                            >
                              {fields2 &&
                                fields2.map((e) => (
                                  <Descriptions.Item label={e.label}>
                                    {e?.value ?? "--"}
                                  </Descriptions.Item>
                                ))}
                            </Descriptions>
                          </Col>
                        </Row>
                        <Row>
                          <Descriptions
                            size="small"
                            column={{
                              xxl: 1,
                              xl: 1,
                              lg: 1,
                              md: 1,
                              sm: 1,
                              xs: 1,
                            }}
                          >
                            {fields3 &&
                              fields3.map((e) => (
                                <Descriptions.Item label={e.label}>
                                  {e?.value ?? "--"}
                                </Descriptions.Item>
                              ))}
                          </Descriptions>
                        </Row>
                      </Col>
                      <Col span={4}>
                        <Row justify={"end"}>
                          <QRCode value={thongTinBN?.maBenhNhan} size={96} />
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  <div className="my-table-custom">
                    <table>
                      <tr>
                        <th style={{ width: "8%" }}>
                          <Typography.Text strong>STT</Typography.Text>
                        </th>
                        <th style={{ width: "36%" }}>
                          <Typography.Text strong>Tên dịch vụ</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Số lượng</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Đơn vị tính</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Đơn giá</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Thành tiền</Typography.Text>
                        </th>
                      </tr>

                      {dsNhomChiDinhCDHA?.map((it, idx) => {
                        return (
                          <>
                            <tr>
                              <td className="ta-c">
                                <Typography.Text>{idx + 1}</Typography.Text>
                              </td>
                              <td className="">
                                <Typography.Text>
                                  {it.tenDichVu}{" "}
                                  {it?.ghiChu ? `- ${it?.ghiChu}` : ""}{" "}
                                </Typography.Text>
                              </td>
                              <td
                                className="ta-r"
                                style={{ textAlign: "center" }}
                              >
                                <Typography.Text>{it.soLuong}</Typography.Text>
                              </td>{" "}
                              <td
                                className="ta-r"
                                style={{ textAlign: "center" }}
                              >
                                <Typography.Text>{it.ghiChu}</Typography.Text>
                              </td>
                              <td className="ta-r">
                                <Typography.Text>
                                  {formatToCurrencyType(it.donGia)}
                                </Typography.Text>
                              </td>
                              <td className="ta-r">
                                <Typography.Text>
                                  {formatToCurrencyType(it.donGia * it.soLuong)}
                                </Typography.Text>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                      <tr>
                        <td className="ta-c" colSpan={4}>
                          <Typography.Text strong>Tổng tiền</Typography.Text>
                        </td>
                        <td className="ta-c">
                          <Typography.Text>
                            {getTongTien(dsNhomChiDinhCDHA)}
                          </Typography.Text>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <Row
                    justify={"space-between"}
                    style={{ marginTop: "48px", marginRight: "24px" }}
                  >
                    <Col></Col>
                    <Col>
                      <Row justify={"center"}>
                        <Typography.Text>
                          {dayjs().format(`Ngày DD [tháng] MM [năm] YYYY`)}
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>
                          Bác sĩ điều trị
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text type="secondary">
                          (Ký và ghi rõ họ tên)
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"} style={{ marginTop: "48px" }}>
                        <Typography.Text strong>
                          {thongTinBN?.bacSyKham ?? ""}
                        </Typography.Text>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </div>
            ) : null}
            {dsNhomChiDinhDT.length > 0 ? (
              <div style={{ pageBreakBefore: "always" }}></div>
            ) : null}
            {dsNhomChiDinhDT.length > 0 ? (
              <div
                className="print-content"
                style={{ padding: "20px 15px 15px 25px" }}
              >
                <HeaderPrintForm></HeaderPrintForm>
                <div className="" style={{ paddingLeft: 24, paddingRight: 24 }}>
                  <div className="container1" style={{ marginBottom: 8 }}>
                    <Row justify={"center"}>
                      <Typography.Title
                        style={{
                          fontWeight: "700",
                          fontSize: 30,
                        }}
                      >
                        PHIẾU CHỈ ĐỊNH ĐIỆN TIM
                      </Typography.Title>
                    </Row>
                    <Row>
                      <Col span={20}>
                        <Row>
                          <Col span={12}>
                            <Descriptions
                              size="small"
                              column={{
                                xxl: 1,
                                xl: 1,
                                lg: 1,
                                md: 1,
                                sm: 1,
                                xs: 1,
                              }}
                            >
                              {fields1 &&
                                fields1.map((e) => (
                                  <Descriptions.Item label={e.label}>
                                    {e?.value ?? "--"}
                                  </Descriptions.Item>
                                ))}
                            </Descriptions>
                          </Col>
                          <Col span={12}>
                            <Descriptions
                              size="small"
                              column={{
                                xxl: 1,
                                xl: 1,
                                lg: 1,
                                md: 1,
                                sm: 1,
                                xs: 1,
                              }}
                            >
                              {fields2 &&
                                fields2.map((e) => (
                                  <Descriptions.Item label={e.label}>
                                    {e?.value ?? "--"}
                                  </Descriptions.Item>
                                ))}
                            </Descriptions>
                          </Col>
                        </Row>
                        <Row>
                          <Descriptions
                            size="small"
                            column={{
                              xxl: 1,
                              xl: 1,
                              lg: 1,
                              md: 1,
                              sm: 1,
                              xs: 1,
                            }}
                          >
                            {fields3 &&
                              fields3.map((e) => (
                                <Descriptions.Item label={e.label}>
                                  {e?.value ?? "--"}
                                </Descriptions.Item>
                              ))}
                          </Descriptions>
                        </Row>
                      </Col>
                      <Col span={4}>
                        <Row justify={"end"}>
                          <QRCode value={thongTinBN?.maBenhNhan} size={96} />
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  <div className="my-table-custom">
                    ``
                    <table>
                      <tr>
                        <th style={{ width: "8%" }}>
                          <Typography.Text strong>STT</Typography.Text>
                        </th>
                        <th style={{ width: "36%" }}>
                          <Typography.Text strong>Tên dịch vụ</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Số lượng</Typography.Text>
                        </th>{" "}
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Đơn vị tính</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Đơn giá</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Thành tiền</Typography.Text>
                        </th>
                      </tr>
                      {dsNhomChiDinhDT?.map((it, idx) => {
                        return (
                          <tr>
                            <td className="ta-c">
                              <Typography.Text>{idx + 1}</Typography.Text>
                            </td>
                            <td className="">
                              <Typography.Text>
                                {it.tenDichVu}{" "}
                                {/* {it?.ghiChu ? `- ${it?.ghiChu}` : ""}{" "} */}
                              </Typography.Text>
                            </td>
                            <td
                              className="ta-c"
                              style={{ textAlign: "center" }}
                            >
                              <Typography.Text>{it.soLuong}</Typography.Text>
                            </td>
                            <td
                              className="ta-c"
                              style={{ textAlign: "center" }}
                            >
                              <Typography.Text>{it.ghiChu}</Typography.Text>
                            </td>
                            <td className="ta-c">
                              <Typography.Text>
                                {formatToCurrencyType(it.donGia)}
                              </Typography.Text>
                            </td>
                            <td className="ta-c">
                              <Typography.Text>
                                {formatToCurrencyType(it.donGia * it.soLuong)}
                              </Typography.Text>
                            </td>
                          </tr>
                        );
                      })}

                      <tr>
                        <td className="ta-c" colSpan={4}>
                          <Typography.Text strong>Tổng tiền</Typography.Text>
                        </td>
                        <td className="ta-c">
                          <Typography.Text>
                            {getTongTien(dsNhomChiDinhDT)}
                          </Typography.Text>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <Row
                    justify={"space-between"}
                    style={{ marginTop: "48px", marginRight: "24px" }}
                  >
                    <Col></Col>
                    <Col>
                      <Row justify={"center"}>
                        <Typography.Text>
                          {dayjs().format(`Ngày DD [tháng] MM [năm] YYYY`)}
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>
                          Bác sĩ điều trị
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text type="secondary">
                          (Ký và ghi rõ họ tên)
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"} style={{ marginTop: "48px" }}>
                        <Typography.Text strong>
                          {thongTinBN?.bacSyKham ?? ""}
                        </Typography.Text>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </div>
            ) : null}
            {dsNhomChiDinhPTTT?.length > 0 && (
              <div style={{ pageBreakBefore: "always" }}></div>
            )}
            {dsNhomChiDinhPTTT?.length > 0 && (
              <div
                className="print-content"
                style={{ padding: "20px 15px 15px 25px" }}
              >
                <HeaderPrintForm></HeaderPrintForm>
                <div className="" style={{ paddingLeft: 24, paddingRight: 24 }}>
                  <div className="container1" style={{ marginBottom: 8 }}>
                    <Row justify={"center"}>
                      <Typography.Title
                        style={{
                          fontWeight: "700",
                          fontSize: 30,
                        }}
                      >
                        PHIẾU CHỈ ĐỊNH PT/TT
                      </Typography.Title>
                    </Row>
                    <Row>
                      <Col span={20}>
                        <Row>
                          <Col span={12}>
                            <Descriptions
                              size="small"
                              column={{
                                xxl: 1,
                                xl: 1,
                                lg: 1,
                                md: 1,
                                sm: 1,
                                xs: 1,
                              }}
                            >
                              {fields1 &&
                                fields1.map((e) => (
                                  <Descriptions.Item label={e.label}>
                                    {e?.value ?? "--"}
                                  </Descriptions.Item>
                                ))}
                            </Descriptions>
                          </Col>
                          <Col span={12}>
                            <Descriptions
                              size="small"
                              column={{
                                xxl: 1,
                                xl: 1,
                                lg: 1,
                                md: 1,
                                sm: 1,
                                xs: 1,
                              }}
                            >
                              {fields2 &&
                                fields2.map((e) => (
                                  <Descriptions.Item label={e.label}>
                                    {e?.value ?? "--"}
                                  </Descriptions.Item>
                                ))}
                            </Descriptions>
                          </Col>
                        </Row>
                        <Row>
                          <Descriptions
                            size="small"
                            column={{
                              xxl: 1,
                              xl: 1,
                              lg: 1,
                              md: 1,
                              sm: 1,
                              xs: 1,
                            }}
                          >
                            {fields3 &&
                              fields3.map((e) => (
                                <Descriptions.Item label={e.label}>
                                  {e?.value ?? "--"}
                                </Descriptions.Item>
                              ))}
                          </Descriptions>
                        </Row>
                      </Col>
                      <Col span={4}>
                        <Row justify={"end"}>
                          <QRCode value={thongTinBN?.maBenhNhan} size={96} />
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  <div className="my-table-custom">
                    <table>
                      <tr>
                        <th style={{ width: "8%" }}>
                          <Typography.Text strong>STT</Typography.Text>
                        </th>
                        <th style={{ width: "36%" }}>
                          <Typography.Text strong>Tên dịch vụ</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Số lượng</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Đơn vị tính</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Đơn giá</Typography.Text>
                        </th>
                        <th style={{ width: "14%" }}>
                          <Typography.Text strong>Thành tiền</Typography.Text>
                        </th>
                      </tr>
                      {/* {dsNhomChiDinhPTTT?.phauThuat?.length > 0 ? (
                        <>
                          <tr>
                            <td colSpan={5}>
                            <Typography.Text strong>{"Phẫu thuật"}</Typography.Text>
                            </td>
                          </tr>
                          {dsNhomChiDinhDVKT?.phauThuat?.map((it, idx) => {
                            return (
                              <tr>
                                <td className="ta-c">
                                  <Typography.Text>{it.index}</Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {it.tenDichVu}
                                  </Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>{it.soLuong}</Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {formatToCurrencyType(it.donGia)}
                                  </Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {formatToCurrencyType(
                                      it.donGia * it.soLuong
                                    )}
                                  </Typography.Text>
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : null} */}
                      {dsNhomChiDinhPTTT?.length > 0 ? (
                        <>
                          <tr>
                            <td colSpan={6}>
                              <Typography.Text strong>
                                {"Thủ thuật"}
                              </Typography.Text>
                            </td>
                          </tr>
                          {dsNhomChiDinhPTTT?.map((it, idx) => {
                            return (
                              <tr>
                                <td className="ta-c">
                                  <Typography.Text>{idx + 1}</Typography.Text>
                                </td>
                                <td className="ta-l">
                                  <Typography.Text>
                                    {it.tenDichVu}{" "}
                                    {/* {it?.ghiChu ? `- ${it?.ghiChu}` : ""}{" "} */}
                                  </Typography.Text>
                                </td>
                                <td
                                  className="ta-c"
                                  style={{ textAlign: "center" }}
                                >
                                  <Typography.Text>
                                    {it.soLuong}
                                  </Typography.Text>
                                </td>{" "}
                                <td
                                  className="ta-c"
                                  style={{ textAlign: "center" }}
                                >
                                  <Typography.Text>{it.ghiChu}</Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {formatToCurrencyType(it.donGia)}
                                  </Typography.Text>
                                </td>
                                <td className="ta-c">
                                  <Typography.Text>
                                    {formatToCurrencyType(
                                      it.donGia * it.soLuong
                                    )}
                                  </Typography.Text>
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : null}
                      <tr>
                        <td className="ta-c" colSpan={4}>
                          <Typography.Text strong>Tổng tiền</Typography.Text>
                        </td>
                        <td className="ta-c">
                          <Typography.Text>
                            {getTongTien(dsNhomChiDinhPTTT)}
                          </Typography.Text>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <Row
                    justify={"space-between"}
                    style={{ marginTop: "48px", marginRight: "24px" }}
                  >
                    <Col></Col>
                    <Col>
                      <Row justify={"center"}>
                        <Typography.Text>
                          {dayjs().format(`Ngày DD [tháng] MM [năm] YYYY`)}
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>
                          Bác sĩ điều trị
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text type="secondary">
                          (Ký và ghi rõ họ tên)
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"} style={{ marginTop: "48px" }}>
                        <Typography.Text strong>
                          {thongTinBN?.bacSyKham ?? ""}
                        </Typography.Text>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </div>
            )}
          </div>
          <Row
            justify={"end"}
            className="footer"
            style={{ gap: "4px", marginTop: "8px" }}
          >
            <Button danger onClick={closeModal}>
              Hủy
            </Button>
            <ReactToPrint
              trigger={() => {
                return (
                  <Button type="primary" onClick={onPrint}>
                    In
                  </Button>
                );
              }}
              content={() => cloneToPrint()}
              onAfterPrint={closeModal}
            />
          </Row>
        </div>
      </Modal>
    </Row>
  );
});
export default PhieuChiDinh;
